import React from "react";
import {t} from "../../shared-services/translate";

const UnavailableCartItem = (props) => {
  const {
    removeButton: RemoveButton,
    product,
    direction = "column",
    className
  } = props;

  return <div
    className={`
      position-absolute
      full-height
      full-width
      top-0
      left-0
      padding-10
    `}
  >
    <div
      className={`
        full-width
        full-height
        position-absolute
        top-0
        left-0
        background-color-white
      `}
      style={{
        mixBlendMode: "color"
      }}>
    </div>

    <div
      className={`
        padding-10
        full-width
        full-height
        position-absolute
        top-0
        left-0
        reveal-on-hover
        z-index-1
        flex
        flex-direction-${direction}
        gap-${direction === "column" ? "5" : "10"}
        align-items-center
        justify-content-center
        ${className}
      `}
      style={{
        backgroundColor: "#666666"
      }}
    >
      <div
        className={`
          position-absolute
        `}
        style={{
          top: "10px",
          right: "10px"
        }}
      >
        <RemoveButton
          product={product}
          size="sm"
          color="transparent"
          iconColor="white"
          className="font-size-body-bigger text-color-dimmed"
          style={{
            fontSize: "16px",
            lineHeight: 0,
            padding: 0
          }}
        />
      </div>

      <div className="text-color-white">
        {t("products.unavailable")}
      </div>
      <RemoveButton
        product={product}
        size="xs"
        className={`
          border-none
          font-size-body-smaller
        `}
      >
        {t("products.remove_from_cart")}
      </RemoveButton>
    </div>
  </div>;
};

export default UnavailableCartItem;
